import { MODULE } from "./add-product-to-order-inline.actionTypes";

export const isFetchingStatus = (state) => state.getIn([MODULE, "isFetchingStatus"]);

export const getProducts = (state) => state.getIn([MODULE, "products"]);

export const isSearchResultOpen = (state) => state.getIn([MODULE, "isSearchResultOpen"]);

export const getSearch = (state) => state.getIn([MODULE, "search"]);

export const getCurrentSearchId = (state) => state.getIn([MODULE, "currentSearchId"]);

export const isSearching = (state) => state.getIn([MODULE, "isSearching"]);
